import { Component, Input } from '@angular/core';
import DOMPurify from 'dompurify';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'crm-activity-rich-text',
  template: `<div class="rte-wrapper">
    <span class="content-div" [innerHTML]="sanitizedRichText | iTrustThisHtml"></span>
  </div>`,
  styleUrls: ['activity-rich-text.component.scss'],
  imports: [CommonModule, GalaxyPipesModule],
})
export class ActivityRichTextComponent {
  sanitizedRichText = '';

  @Input({ required: true }) set richText(rteValue: string) {
    const cleanedText = rteValue
      // Remove empty paragraphs
      .replace(/<p>&nbsp;<\/p>/g, '')
      // Replace &nbsp; with normal spaces
      .replace(/&nbsp;/g, ' ')
      .trim()
      //Remove leading br tags that cause empty space
      .replace(/^(<br\s*\/?>)+/gi, '');

    this.sanitizedRichText = DOMPurify.sanitize(cleanedText);
  }
}
